import { render, staticRenderFns } from "./clickToCopy.vue?vue&type=template&id=427bf11e&scoped=true&"
import script from "./clickToCopy.vue?vue&type=script&lang=js&"
export * from "./clickToCopy.vue?vue&type=script&lang=js&"
import style0 from "./clickToCopy.vue?vue&type=style&index=0&id=427bf11e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427bf11e",
  null
  
)

export default component.exports